import { pathProxy } from "@/utils/forms-proxy"
import { useForm } from "@mantine/form"
import { useMemo, useRef } from "react"
import { FormProps, MantineFormContext } from "./mantine-form-context"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Form<T extends Record<string, any>>({
  onSubmit,
  children,
  handleValidationFailure,
  ...rest
}: FormProps<T>) {
  const _ = useMemo(() => pathProxy<T>(), [])
  const form = useForm<T>(rest)
  const formRef = useRef<HTMLFormElement>(null)
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <MantineFormContext.Provider value={[form as any, formRef]}>
      <form
        ref={formRef}
        onSubmit={form.onSubmit((values, e) => {
          onSubmit(values, e, form)
        }, handleValidationFailure)}
      >
        {typeof children === "function" ? children(form, _) : children}
      </form>
    </MantineFormContext.Provider>
  )
}
